<template>
  <div>
    <el-row class="tac">
      <el-col :span="12">
        <span>{{ getgeLanguage(infoLists.infoNameEn)=='zh'?infoLists.info_NAME:infoLists.infoNameEn }}</span>
        <div class="popLeftMenu">
          <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" router
            background-color="rgb(196, 196, 233,0.9)" text-color="#000" unique-opened
            active-text-color="rgb(196, 196, 233,1.0)" :default-openeds="active2">
            <label v-for="(item, index) in infoLists.info_classes"  :key="index + ''">
              <el-submenu :index="index + ''" v-if="item.isMenus == false&&(item.isPublic==true||$user!=null)">
                <template slot="title">
                  <span>{{ getgeLanguage( item.infoClassNameEn)=='zh'? item.info_CLASS_NAME: item.infoClassNameEn}}</span>
                </template>
                <label v-for="(item2, index2) in item.infoMenus" :key="index2 + '3级'">

                  <el-menu-item  :index="index2 + ''" v-if="(item2.isPublic3==true||$user!=null)" :class="{ styles: styles[0] == index & styles[1] == index2 }"
                    :route="{ path: '/' + item2.router, query: { htmlpath: item2.htmlPath, infoID: infoLists.info_ID, styles: [index + '', index2 + ''], active: [index], threeMenus: item2.info_ID, t: Date.now() } }">{{ getgeLanguage(item2.infoMenusNameEn)=='zh'?item2.info_NAME:item2.infoMenusNameEn }} </el-menu-item>
                </label>
              </el-submenu>
              <el-menu-item :index="index + ''" v-if="item.isMenus == true&&(item.isPublic==true||$user!=null)" :class="{ styles: styles[0] == index }"
                :route="{ path: '/' + item.router, query: { htmlpath: item.htmlPath, styles: [index + ''], two: item.info_CLASS_ID, infoID: infoLists.info_ID, t: Date.now() } }">
                <span slot="title">{{ getgeLanguage( item.infoClassNameEn)=='zh'? item.info_CLASS_NAME: item.infoClassNameEn}}</span>
              </el-menu-item>
            </label>



          </el-menu>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openList: [],
      active2: [],
      infoLists: [],
      infoId: '',
    }
  },
  props: [
    'active', 'styles', 'infoID'
  ],

  created() {
    this.getInfoClass()
  }, methods: {
    getInfoClass() {
      if (sessionStorage.getItem('InfoList') == null) {
        this.axios.post("/info/getInfo")
          .then(resp => {
            if (resp.data.status == 1) {
              this.infoLists = resp.data.result
              console.log(resp.data.result)
              // if(this.infoID==null){alert("meiyou")}
            if(this.getleft(this.infoID)){
              for (let i = 0; i < this.infoLists.length; i++) {
                if (this.infoID == this.infoLists[i].info_ID) {
                  this.infoLists = this.infoLists[i]
                }
              }
            }else{
              this.infoLists = this.infoLists[0]
            }
             
              sessionStorage.setItem("InfoList", JSON.stringify(resp.data.result))
            } else {
              alert("拿取数据失败")
            }
          })
          .catch((err) => {
            // alert("出错了")
            console.log(err)
          })
      } else {
        this.infoLists = JSON.parse(sessionStorage.getItem("InfoList"))
        if(this.getleft(this.infoID)){
              for (let i = 0; i < this.infoLists.length; i++) {
                if (this.infoID == this.infoLists[i].info_ID) {
                  this.infoLists = this.infoLists[i]
                }
              }
            }else{
              this.infoLists = this.infoLists[0]
            }
      }
      if (typeof this.active == "string") {
        this.active2 = [this.active]
      } else {
        this.active2 = this.active
      }

    },               getgeLanguage(data){
       let language=localStorage.getItem('languageSet')
       if(language==null||data==null){
        return 'zh'
       }else{
        return language
       }
        }, handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },getleft(data){
      var bileam=false
      for (let i = 0; i < this.infoLists.length; i++) {
          if (data == this.infoLists[i].info_ID) {
            bileam=true
          }
        }
        return bileam
    }
  }
}
</script>
  
<style scoped>
.tac {

  color: white;
}

.popLeftMenu {
  margin-top: 20px;

}

.el-col-12 {
  width: 100%;
}

.el-menu-item {
  font-size: 14px;
  color: black;

}

.styles {
  font-size: 16px;
  font-weight: 600px;
  color: black;
}

/*.styles /deep/ element.style{
  font-size: 18px;
}
 .styles /deep/ element.style {
  background-color: rgb(64, 74, 80);
}  */
</style>


// WEBPACK FOOTER //
// src/components/work/LeftMenus.vue